const s=()=>({values:{xs:0,sm:600,md:960,lg:1280,xl:1920}});export{s as default};
